/* vona-products-first */
var FR_LOCALE=(document.documentElement.lang||'').toLowerCase().indexOf('fr')===0;
/* VONA — every product URL and fetch goes through the active locale root
   ('/' on the US store, '/fr/' on the French one). Without this a French
   shopper clicking a colourway card lands on the English page. */
var VROOT=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
/* VONA — press sheet behaviours. No dependencies. */
(function () {
  'use strict';
  var $  = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- misregistration on scroll (touch only; desktop keeps hover) ---------- */
  function offRegisterOnScroll() {
    if (!('IntersectionObserver' in window)) return;
    if (window.matchMedia('(hover: hover)').matches) return;
    if (reduce) return;
    var seen = new WeakSet();
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting || seen.has(en.target)) return;
        seen.add(en.target);
        en.target.classList.add('is-off');
        setTimeout(function () { en.target.classList.remove('is-off'); }, 2500);
      });
    }, { threshold: 0.55 });
    $$('.v-shot').forEach(function (s) { io.observe(s); });
  }

  /* ---------- colorway rotator ----------
     Rotates on its own every 20s, then stops permanently on first interaction.
     Baymard does not recommend auto-rotation on images used to evaluate a
     product, so the moment the visitor takes control, we hand it over.
  ------------------------------------------------------------------------ */
  function rotator() {
    var root = $('[data-v-rot]');
    if (!root) return;
    var ways;
    try { ways = JSON.parse(root.getAttribute('data-v-rot')); } catch (e) { return; }
    if (!ways || !ways.length) return;

    var ms = parseInt(root.getAttribute('data-v-interval'), 10) || 20000;
    var i = 0, timer = null, running = !reduce;

    var heroShot = document.querySelector('.v-hero .v-shot') || document.querySelector('[data-v-gal] .v-shot');
    var heroBase = heroShot ? heroShot.style.backgroundImage : '';

    function paint() {
      var w = ways[i];
      /* A colourway swaps the photograph when one exists for it. It never
         tints the product: a CSS filter would misrepresent the colour. */
      if (heroShot) {
        heroShot.style.backgroundImage = w.img ? 'url("' + w.img + '")' : heroBase;
      }
      $$('[data-v-cw-label]').forEach(function (e) { e.textContent = w.name; });
      activeWay = (w.name || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
      applyGallery();

      /* the buy button always points at the colourway on screen */
      var shop = $('[data-v-shop]');
      if (shop) {
        var base = w.url || shop.getAttribute('data-v-base-url') || '';
        if (base) {
          shop.href = w.url
            ? base
            : base + (base.indexOf('?') > -1 ? '&' : '?') + 'vona-color=' + encodeURIComponent(w.name);
        }
        var txt = $('[data-v-shop-text]', shop);
        if (txt) txt.textContent = (shop.getAttribute('data-v-label') || 'Shop') + ' ' + w.name;
      }
      $$('[data-v-cw]').forEach(function (b) {
        var on = parseInt(b.getAttribute('data-v-cw'), 10) === i;
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
        b.classList.toggle('is-running', on && running);
      });
    }
    function tick() {
      var bar = $('[data-v-cw="' + i + '"] .v-cw__bar i');
      if (bar) { bar.style.transition = 'none'; bar.style.width = '0'; void bar.offsetWidth; bar.style.transition = ''; }
      paint();
      timer = setTimeout(function () { i = (i + 1) % ways.length; tick(); }, ms);
    }
    function stop() {
      if (!running) return;
      running = false;
      clearTimeout(timer);
      $$('.v-cw__bar i').forEach(function (e) { e.style.transition = 'none'; e.style.width = '0'; });
      var hint = $('[data-v-cw-hint]');
      if (hint) hint.textContent = hint.getAttribute('data-stopped') || '';
      paint();
    }
    document.addEventListener('click', function (e) {
      var b = e.target.closest('[data-v-cw]');
      if (!b) return;
      stop();
      i = parseInt(b.getAttribute('data-v-cw'), 10);
      paint();
    });
    if (running) { tick(); } else { paint(); }
  }

  /* ---------- gallery filtering ----------
     Two filters at once: the category tabs, and the active colourway.
     An image with no colourway belongs to every colourway.
  --------------------------------------------------------------- */
  var activeCat = 'all';
  var activeWay = '';
  function applyGallery() {
    $$('[data-v-gal] figure').forEach(function (f) {
      var cat = f.getAttribute('data-cat') || '';
      var way = f.getAttribute('data-cw') || '';
      var okCat = activeCat === 'all' || cat === activeCat;
      var okWay = !way || !activeWay || way === activeWay;
      f.hidden = !(okCat && okWay);
    });
  }
  function filters() {
    document.addEventListener('click', function (e) {
      var b = e.target.closest('[data-v-filters] button');
      if (!b) return;
      var scope = b.closest('section') || document;
      activeCat = b.getAttribute('data-cat');
      $$('[data-v-filters] button', scope).forEach(function (x) {
        x.setAttribute('aria-pressed', x === b ? 'true' : 'false');
      });
      applyGallery();
    });
  }

  /* ---------- sticky buy bar on the product page ---------- */
  function stickyBuy() {
    var bar = $('[data-v-stick]');
    if (!bar) return;
    var form = $('product-form .product-form__submit') || $('.product-form__submit');
    if (!form) { bar.remove(); return; }
    function check() {
      var r = form.getBoundingClientRect();
      var drawerOpen = document.body.classList.contains('overflow-hidden')
        || !!document.querySelector('cart-drawer.animate.active');
      bar.classList.toggle('is-on', !drawerOpen && (r.bottom < 0 || r.top > window.innerHeight));
    }
    window.addEventListener('scroll', check, { passive: true });
    window.addEventListener('resize', check);
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-v-stick-add]')) { e.preventDefault(); form.click(); }
    });
    check();
  }


  /* ---------- variant options: size row + colour swatches ----------
     Dawn renders every option as a wrapping list of text pills. Thirteen
     colour names wrapping over five lines is the single ugliest thing on
     the page, so colours become swatches and the chosen name moves into
     the legend.
  ------------------------------------------------------------------- */
  var SWATCH = {
    'noir profond':'#14140F', 'bleu glace':'#A9C7DA', 'gris chine graphite':'#6E7176',
    'rose fuchsia electrique':'#E0388A', 'bleu royal profond':'#23407E',
    'violet profond':'#4B2A56', 'vert canard petrole':'#17656A', 'bleu cyan vif':'#12A5CE',
    'brun bronze':'#7A5327', 'gris anthracite':'#3A3D42', 'beige sable chaud':'#C9AE8B',
    'mauve chine':'#9A8792', 'bordeaux prune':'#5C2233',
    'teal':'#1B6E70','press black':'#111312','olive':'#4E5A3A','bone':'#E8DCCB',
    'plum':'#6E4A52','navy':'#2E3A56','clay':'#9B5B45','graphite':'#6E7176',
    /* Series 02 — canonical names. One spelling, English, exact. */
    'blue':'#7FA8D9',
    'black':'#15130F',
    'coffee':'#3E2B22',
    'green':'#1B6E5A',
    'chestnut':'#5C3A2E',
    'orchid pink':'#E8A0C8',
    'provence blue':'#6D8FC7',
    'gray':'#7A7D82',
    'red':'#C22B36',
    'mocha':'#8A6E5B',
    'stone':'#B8AC9E',
    'ice gray':'#C9CDD1',
    'army green':'#4E5A3A',
    'pumpkin':'#C46A1F',
    'raspberry':'#B0275C',
    'pink':'#F0B7CD',
    'pistachio':'#B5C4A1',
    'leopard ice cream':'#E8DCC8',
    'leopard blue':'#4A6FA0',
    'leopard red':'#B03030',
    'leopard purple':'#6B4E8E',
    'leopard pink purple':'#B57EB5',
    'leopard black':'#1A1714',
    'leopard coffee':'#4A342A',
    'leopard wine':'#722F42',
    'leopard graphite gray':'#4E5257',
    'leopard gray':'#8B8E93', 'noir':'#161616','black':'#161616','gris glacial':'#75808F','ice gray':'#75808F','ice grey':'#75808F','gris':'#7E8081','gray':'#7E8081','grey':'#7E8081','framboise':'#C03A62','raspberry':'#C03A62','bleu':'#B9D3E8','blue':'#B9D3E8','rose orchidee':'#DDA3D6','orchid pink':'#DDA3D6','vert':'#1E7470','green':'#1E7470','bleu provence':'#7D92D6','provence blue':'#7D92D6','cafe':'#4A3129','coffee':'#4A3129','moka':'#A08881','mocha':'#A08881','pierre':'#B3A296','stone':'#B3A296','rose':'#F0C9D4','pink':'#F0C9D4','rouge':'#BE2028','red':'#BE2028','chataigne':'#6E2E3A','chestnut':'#6E2E3A','vert armee':'#5A6A3C','army green':'#5A6A3C','citrouille':'#C4642A','pumpkin':'#C4642A','pistache':'#C2CDB4','pistachio':'#C2CDB4'
  };
  var HUES = [
    ['noir','#14140F'],['black','#14140F'],['blanc','#F2F2EE'],['white','#F2F2EE'],
    ['anthracite','#3A3D42'],['gris','#6E7176'],['grey','#6E7176'],['gray','#6E7176'],
    ['bordeaux','#5C2233'],['prune','#5C2233'],['rouge','#B22B2B'],['red','#B22B2B'],
    ['rose','#E0388A'],['pink','#E0388A'],['fuchsia','#E0388A'],
    ['violet','#4B2A56'],['mauve','#9A8792'],['purple','#4B2A56'],
    ['canard','#17656A'],['petrole','#17656A'],['vert','#4E5A3A'],['green','#4E5A3A'],
    ['cyan','#12A5CE'],['royal','#23407E'],['marine','#23407E'],['navy','#23407E'],
    ['bleu','#3E6EA8'],['blue','#3E6EA8'],
    ['bronze','#7A5327'],['brun','#7A5327'],['brown','#7A5327'],['camel','#B08A5A'],
    ['beige','#C9AE8B'],['sable','#C9AE8B'],['creme','#E8DCCB'],['ivoire','#E8DCCB']
  ];
  function norm(s) {
    return (s || '').toLowerCase()
      .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
      .replace(/\s+/g, ' ').trim();
  }
  function swatchFor(name) {
    var k = norm(name);
    if (SWATCH[k]) return SWATCH[k];
    for (var i = 0; i < HUES.length; i++) { if (k.indexOf(HUES[i][0]) !== -1) return HUES[i][1]; }
    return '#C9CCCB';
  }
  function labelText(label) {
    var n = label.firstChild;
    return n && n.nodeType === 3 ? n.textContent.trim() : label.textContent.trim();
  }


  /* US women's sizing is the French number minus 32 — the conversion both
     reference charts agree on. Computed, never hard-coded, so it stays
     right for sizes we have not been told the French equivalent of. */
  function usFromFr(fr) {
    var nums = String(fr).match(/\d+/g);
    if (!nums || !nums.length) return String(fr).trim();
    var us = nums.map(function (n) { return parseInt(n, 10) - 32; })
                 .filter(function (n) { return n >= 0; });
    if (!us.length) return String(fr).trim();
    var uniq = us.filter(function (v, i) { return us.indexOf(v) === i; });
    return 'US ' + uniq.join('\u2013');
  }


  /* ---------- display-time translation ----------
     Product option names and colour values live in the shop's data, not in
     the theme, so a theme file cannot rewrite them. It can render them in
     English. Only when the visitor is on an English locale — a French
     visitor keeps the French names.
  --------------------------------------------------------------------- */
  var EN_LOCALE = /^en/i.test(document.documentElement.lang || '');
  var TRANSLATE = {
    'taille': 'Size',
    'couleur': 'Color',
    'coloris': 'Color',
    'noir profond': 'Deep Black',
    'bleu glace': 'Ice Blue',
    'gris chine graphite': 'Heather Graphite',
    'rose fuchsia electrique': 'Electric Fuchsia',
    'bleu royal profond': 'Deep Royal Blue',
    'violet profond': 'Deep Violet',
    'vert canard petrole': 'Petrol Teal',
    'bleu cyan vif': 'Bright Cyan',
    'brun bronze': 'Bronze Brown',
    'gris anthracite': 'Anthracite Gray',
    'beige sable chaud': 'Warm Sand',
    'mauve chine': 'Heather Mauve',
    'bordeaux prune': 'Burgundy Plum'
  };
  function tr(v) {
    if (!EN_LOCALE) return v;
    var k = norm(v);
    if (TRANSLATE[k]) return TRANSLATE[k];
    /* Only fall back to fuzzy matching on a value long enough to be a name.
       Without this, the size "M" matched "mauve chine". */
    if (k.length < 4) return v;
    /* tolerate a shortened or slightly different wording: take the longest
       key that lines up with the value from the start, either way round. */
    var best = '';
    Object.keys(TRANSLATE).forEach(function (key) {
      if (key.length < 4) return;
      if ((key.indexOf(k) === 0 || k.indexOf(key) === 0) && key.length > best.length) best = key;
    });
    return best ? TRANSLATE[best] : v;
  }

  /* Cart lines print "Taille : M" — same treatment, same guard. */
  function translateCartOptions() {
    if (!EN_LOCALE) return;
    $$('.cart-item .product-option, .cart-drawer .product-option').forEach(function (el) {
      if (el.getAttribute('data-v-tr')) return;
      var txt = el.textContent.replace(/\s+/g, ' ').trim();
      var m = txt.match(/^(.+?)\s*:\s*(.+)$/);
      if (!m) return;
      var name = tr(m[1]);
      var value = tr(m[2]);
      if (name === m[1] && value === m[2]) { el.setAttribute('data-v-tr', '1'); return; }
      el.textContent = name + ': ' + value;
      el.setAttribute('data-v-tr', '1');
    });
  }


  /* ---------- navigation labels ----------
     Switching the store's default language swapped Shopify's layers: the
     French wording became the English primary, and the old English
     translations were filed under French. The menus now read inverted in
     both directions. Until the translation layers are cleaned up, the
     theme renders the right language whatever it is served.
  --------------------------------------------------------------------- */
  var NAV_EN = {
    'accueil': 'Home', 'boutique': 'Shop', 'les packs': 'Packs', 'packs': 'Packs',
    'guide des tailles': 'Size guide', 'nous contacter': 'Contact',
    'a propos': 'About', 'suivi de commande': 'Track your order',
    'livraison & retours': 'Shipping & returns', 'livraison et retours': 'Shipping & returns',
    'mentions legales': 'Legal notice', 'politique de confidentialite': 'Privacy policy',
    'politique de cookies': 'Cookie policy', 'politique d\'expedition': 'Shipping policy',
    'politique de retour': 'Return policy', 'conditions generales de vente': 'Terms of sale',
    'conditions d\'utilisation du site': 'Terms of use', 'panier': 'Cart', 'rechercher': 'Search'
  };
  var NAV_FR = {
    'home': 'Accueil', 'shop': 'Boutique', 'the packs': 'Les packs', 'packs': 'Les packs',
    'size guide': 'Guide des tailles', 'about': 'À propos',
    'track your order': 'Suivi de commande', 'shipping & returns': 'Livraison & Retours',
    'legal notice': 'Mentions légales', 'privacy policy': 'Politique de confidentialité',
    'cookie policy': 'Politique de cookies', 'shipping policy': "Politique d'expédition",
    'return policy': 'Politique de retour', 'terms of sale': 'Conditions générales de vente',
    'terms of use': "Conditions d'utilisation du site", 'cart': 'Panier', 'search': 'Rechercher'
  };
  function fixNav() {
    /* L2 — purification: the logo is the way home, the tiers are the way
       to the packs. Their nav entries are noise and are removed. */
    $$('.header__inline-menu .list-menu__item').forEach(function (a) {
      var el = a.closest('li') || a;
      var href = (a.getAttribute('href') || '').replace(/^\/(fr|en)(\/|$)/, '/');
      var t = norm(a.textContent);
      if (href === '/' || /\/collections\/packs\/?$/.test(href) ||
          t === 'home' || t === 'accueil' || t === 'packs' || t === 'les packs') {
        el.style.display = 'none';
      }
    });
    var map = EN_LOCALE ? NAV_EN : NAV_FR;
    $$('.header__menu-item span, .header__menu-item, .list-menu__item span').forEach(function (el) {
      if (el.children.length) return;
      if (el.getAttribute('data-v-nav')) return;
      var t = el.textContent.replace(/\s+/g, ' ').trim();
      var hit = map[norm(t)];
      el.setAttribute('data-v-nav', '1');
      if (hit && hit !== t) el.textContent = hit;
    });
  }

  function dressOptions() {
    $$('.product-form__input--pill').forEach(function (fs) {
      var legend = fs.querySelector('legend.form__label, .form__label');
      if (!legend) return;
      var name = norm(legend.getAttribute('data-v-base') || legend.textContent);
      if (!legend.getAttribute('data-v-base')) {
        /* strip any name we already appended, so a second init cannot
           turn "Colour" into "Colour — Teal — Teal". */
        legend.setAttribute('data-v-base', tr(legend.textContent.split('—')[0].trim()));
      }

      var isColor = /couleur|color|colori|farbe/.test(name);
      var isSize  = /taille|size|talla/.test(name);
      fs.setAttribute('data-v-opt', isColor ? 'color' : (isSize ? 'size' : 'other'));

      /* wrap inputs+labels once, so CSS grid has a container */
      if (!fs.querySelector('.v-optgrid')) {
        var grid = document.createElement('div');
        grid.className = 'v-optgrid';
        var kids = Array.prototype.slice.call(fs.childNodes).filter(function (n) {
          return n !== legend && !(n.nodeType === 1 && n.matches('.v-optgrid'));
        });
        kids.forEach(function (n) { grid.appendChild(n); });
        fs.appendChild(grid);
      }

      /* US first. "S (34/36)" becomes S, with FR 34/36 as a footnote —
         the letter is what an American reads, the number is the option. */
      if (isSize) {
        $$('input[type=radio]', fs).forEach(function (input) {
          var label = fs.querySelector('label[for="' + input.id + '"]');
          if (!label || label.getAttribute('data-v-size')) return;
          var raw = labelText(label);
          var m = raw.match(/^([^(]+)\(([^)]+)\)\s*$/);
          if (!m) return;
          var hidden = label.querySelector('.visually-hidden');
          label.setAttribute('data-v-size', '1');
          label.textContent = '';
          var main = document.createElement('b');
          main.className = 'v-size';
          main.textContent = m[1].trim();
          var alt = document.createElement('i');
          alt.className = 'v-size-alt';
          /* FR shopper sees FR sizing, EN shopper sees US sizing. */
          alt.textContent = EN_LOCALE ? usFromFr(m[2]) : 'FR ' + m[2].trim();
          label.appendChild(main);
          label.appendChild(alt);
          if (hidden) label.appendChild(hidden);
          label.setAttribute('title', raw + ' — ' + usFromFr(m[2]) + ' (FR ' + m[2].trim() + ')');
        });
      }

      /* size and any other option: show the translated name */
      if (!isColor) {
        var base = legend.getAttribute('data-v-base');
        if (base && legend.textContent.trim() !== base) legend.textContent = base;
        return;
      }

      var selectedName = '';
      $$('input[type=radio]', fs).forEach(function (input) {
        var label = fs.querySelector('label[for="' + input.id + '"]');
        if (!label) return;
        var v = labelText(label);
        label.style.background = swatchFor(v);
        label.setAttribute('title', tr(v));
        label.setAttribute('aria-label', tr(v));
        if (input.checked) selectedName = tr(v);
      });

      if (selectedName) {
        var base = legend.getAttribute('data-v-base') || 'Couleur';
        legend.innerHTML = base + ' — <span class="v-optname"></span>';
        legend.querySelector('.v-optname').textContent = selectedName;
      }
    });
  }

  /* Dawn swaps the picker markup on every variant change — re-dress after. */
  function watchOptions() {
    dressOptions();
    var host = $('.product__info-container') || $('main');
    if (!host || !('MutationObserver' in window)) return;
    var pending = false;
    new MutationObserver(function () {
      if (pending) return;
      pending = true;
      requestAnimationFrame(function () { pending = false; dressOptions(); translateCartOptions(); });
    }).observe(host, { childList: true, subtree: true });
  }


  /* ---------- cart upsells: add without leaving the drawer ----------
     Uses the same Section Rendering call Dawn's own product form makes,
     so the drawer redraws in place — reward bar and totals included.
  ------------------------------------------------------------------- */
  function upsells() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-v-up-add]');
      if (!btn || btn.disabled) return;
      e.preventDefault();

      var drawer = document.querySelector('cart-drawer');
      var body = new FormData();
      body.append('id', btn.getAttribute('data-v-up-add'));
      body.append('quantity', 1);
      if (drawer && drawer.getSectionsToRender) {
        body.append('sections', drawer.getSectionsToRender().map(function (s) { return s.id; }).join(','));
        body.append('sections_url', window.location.pathname);
      }

      var label = btn.textContent;
      btn.disabled = true;
      btn.classList.add('is-busy');
      btn.textContent = '…';

      fetch((window.routes && routes.cart_add_url) || VROOT+'cart/add', {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
        body: body
      })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (res.status) throw new Error(res.description || res.message);
          if (drawer && drawer.renderContents && res.sections) {
            drawer.renderContents(res);
          } else {
            window.location.reload();
          }
        })
        .catch(function () {
          btn.disabled = false;
          btn.classList.remove('is-busy');
          btn.textContent = label;
        });
    });
  }


  /* Wide tables (the size guide) must scroll inside their own box,
     never make the page scroll sideways. */
  function wrapTables() {
    $$('.rte table').forEach(function (t) {
      if (t.parentElement && t.parentElement.classList.contains('v-tablewrap')) return;
      var w = document.createElement('div');
      w.className = 'v-tablewrap';
      t.parentNode.insertBefore(w, t);
      w.appendChild(t);
    });
  }


  /* ---------- misregistration on collection cards ----------
     Dawn's cards use <img>, not a background, so the ghost layer needs the
     source copied into a custom property before CSS can reach it.
  --------------------------------------------------------- */
  function dressCards() {
    $$('.card__media .media').forEach(function (m) {
      if (m.getAttribute('data-v-ghost')) return;
      var img = m.querySelector('img');
      if (!img) return;
      var src = img.currentSrc || img.src;
      if (!src) return;
      m.style.setProperty('--v-card-img', 'url("' + src + '")');
      m.setAttribute('data-v-ghost', '1');
    });

    if (!('IntersectionObserver' in window)) return;
    if (window.matchMedia('(hover: hover)').matches) return;
    if (reduce) return;
    var seen = new WeakSet();
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting || seen.has(en.target)) return;
        seen.add(en.target);
        en.target.classList.add('is-off');
        setTimeout(function () { en.target.classList.remove('is-off'); }, 2500);
      });
    }, { threshold: 0.5 });
    $$('.card__media .media').forEach(function (m) { io.observe(m); });
  }


  /* ---------- arrive from the homepage on a colourway ----------
     The gallery button carries ?vona-color=Press Black. Match it against
     the swatch labels — raw or translated — and select it.
  ------------------------------------------------------------------ */
  function preselectColor() {
    var want = new URLSearchParams(location.search).get('vona-color');
    if (!want) return;
    var target = norm(want);
    var fs = $('.product-form__input--pill[data-v-opt="color"]');
    if (!fs) return;
    var found = null;
    $$('input[type=radio]', fs).forEach(function (input) {
      if (found) return;
      var label = fs.querySelector('label[for="' + input.id + '"]');
      if (!label) return;
      var raw = norm(labelText(label));
      var en = norm(tr(labelText(label)));
      if (raw === target || en === target) found = input;
    });
    if (found && !found.checked) {
      found.checked = true;
      found.dispatchEvent(new Event('change', { bubbles: true }));
      found.click();
    }
  }


  /* ---------- bundle tiers: pick everything on this page ----------
     2x / 3x unfold size+colour rows right here. Add posts the pack
     product with the choices written into line item properties, then
     redraws the cart drawer in place — no navigation anywhere.
  ---------------------------------------------------------------- */
  function bundle() {
    var root = $('[data-v-bundle]');
    if (!root) return;
    root.addEventListener('click', function (e) {
      var tile = e.target.closest('[data-v-tier]');
      if (tile) {
        var t = tile.getAttribute('data-v-tier');
        $$('[data-v-tier]', root).forEach(function (b) {
          var on = b === tile;
          b.classList.toggle('is-current', on);
          b.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        $$('[data-v-panel]', root).forEach(function (p) {
          p.hidden = p.getAttribute('data-v-panel') !== t;
        });
        return;
      }

      var add = e.target.closest('[data-v-bundle-add]');
      if (!add || add.disabled) return;
      var panel = add.closest('[data-v-panel]');
      var word = add.getAttribute('data-v-label') || 'Item';
      var props = {};
      $$('[data-v-row]', panel).forEach(function (row, i) {
        var size = row.querySelector('[data-v-sel="size"]');
        var color = row.querySelector('[data-v-sel="color"]');
        var parts = [];
        if (size) parts.push(size.value);
        if (color) parts.push(tr(color.value));
        props[word + ' ' + (i + 1)] = parts.join(' / ');
      });

      var drawer = document.querySelector('cart-drawer');
      var body = new FormData();
      body.append('id', add.getAttribute('data-v-bundle-add'));
      body.append('quantity', 1);
      Object.keys(props).forEach(function (k) {
        body.append('properties[' + k + ']', props[k]);
      });
      if (drawer && drawer.getSectionsToRender) {
        body.append('sections', drawer.getSectionsToRender().map(function (x) { return x.id; }).join(','));
        body.append('sections_url', window.location.pathname);
      }

      var label = add.textContent;
      add.disabled = true;
      add.textContent = '…';
      fetch((window.routes && routes.cart_add_url) || VROOT+'cart/add', {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
        body: body
      })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (res.status) throw new Error(res.description || res.message);
          add.disabled = false;
          add.textContent = label;
          if (drawer && drawer.renderContents && res.sections) drawer.renderContents(res);
          else window.location.href = '/cart';
        })
        .catch(function () {
          add.disabled = false;
          add.textContent = label;
        });
    });
  }


  /* ---------- product gallery follows the colour ----------
     Pick Blue: only Blue's photos remain, plus any untagged (generic)
     shot. An image belongs to a colour through either its alt text
     (exact canonical name) or its filename (starts with the colour's
     handle — longest name wins, so provence-blue never matches blue).
     A colour with no tagged photos falls back to showing everything.
  ------------------------------------------------------------------ */
  function mediaColour() {
    var fs = $('.product-form__input--pill[data-v-opt="color"]');
    if (!fs) return;

    var names = Object.keys(SWATCH).sort(function (a, b) { return b.length - a.length; });
    var handles = names.map(function (n) { return n.replace(/[^a-z0-9]+/g, '-'); });

    function tagOf(img) {
      if (!img) return '';
      var alt = norm(img.alt || '');
      for (var i = 0; i < names.length; i++) {
        var n = names[i];
        if (alt === n || alt.indexOf(n + ' ') === 0 || alt.indexOf(n + '-') === 0) return n;
      }
      var src = (img.currentSrc || img.src || '').split('/').pop().toLowerCase();
      for (var j = 0; j < handles.length; j++) {
        if (src.indexOf(handles[j] + '-') === 0 || src.indexOf(handles[j] + '.') === 0) return names[j];
      }
      return '';
    }

    function items() {
      return $$('.product__media-list .product__media-item, .thumbnail-list .thumbnail-list__item');
    }

    function apply() {
      /* Dawn re-renders the variant picker on change — never trust a cached node */
      var fsNow = $('.product-form__input--pill[data-v-opt="color"]');
      if (!fsNow) return;
      var checked = fsNow.querySelector('input[type=radio]:checked');
      if (!checked) return;
      var label = fsNow.querySelector('label[for="' + checked.id + '"]');
      if (!label) return;
      var raw = norm(labelText(label));
      var en = norm(tr(labelText(label)));

      var list = items();
      var anyMatch = false;
      var tags = list.map(function (it) {
        var t = tagOf(it.querySelector('img'));
        if (t && (t === raw || t === en)) anyMatch = true;
        return t;
      });

      list.forEach(function (it, i) {
        var t = tags[i];
        /* untagged images always show; tagged ones only for their colour.
           If nothing matches this colour, show the lot rather than a void. */
        var show = !anyMatch || !t || t === raw || t === en;
        it.style.display = show ? '' : 'none';
      });

      /* Dawn's thumbnail layout renders only the active slide; if the filter
         just hid it, hand the stage to the first image of this colour. */
      var mains = list.filter(function (it) { return it.classList.contains('product__media-item'); });
      var act = null;
      mains.forEach(function (it) { if (it.classList.contains('is-active')) act = it; });
      if (!act || act.style.display === 'none') {
        var first = null;
        mains.forEach(function (it) { if (!first && it.style.display !== 'none') first = it; });
        if (first && first !== act) {
          var mid = first.getAttribute('data-media-id');
          var gal = first.closest('media-gallery');
          if (gal && mid && typeof gal.setActiveMedia === 'function') {
            gal.setActiveMedia(mid, false);
          } else {
            if (act) act.classList.remove('is-active');
            first.classList.add('is-active');
          }
        }
      }
    }

    /* capture phase: Dawn's variant picker stops propagation in bubble */
    document.addEventListener('change', function (e) {
      if (e.target && e.target.closest && e.target.closest('.product-form__input--pill[data-v-opt="color"]')) setTimeout(apply, 150);
    }, true);
    /* Dawn re-renders picker and may swap media DOM on variant change */
    var host = $('main') || $('.product__media-wrapper') || document.body;
    if (host && 'MutationObserver' in window) {
      var pending = false;
      new MutationObserver(function () {
        if (pending) return;
        pending = true;
        requestAnimationFrame(function () { pending = false; apply(); });
      }).observe(host, { childList: true, subtree: true });
    }
    setTimeout(apply, 500);
  }

  function openSizeOnDesktop() {
    /* L12 — the conversion table is the answer to the #1 question; on a
       wide screen it starts open instead of hiding behind a click. */
    if (window.innerWidth < 990) return;
    var d = document.querySelector('[data-v-open-desktop]');
    if (d) d.open = true;
  }

  /* ---------- Boutique: colourway card grid built from live product JSON ----------
     One card per colourway of the legging + the packs + a locked leopard card.
     Cards link to the PDP with the colour preselected. Pills, colour swatches
     and collection checkboxes filter the grid; no fake reviews are shown.
  ------------------------------------------------------------------------------- */
  function boutique() {
    var root = $('[data-v-boutique]');
    if (!root) return;
    var grid = $('[data-v-btq-grid]', root);
    var leg = root.getAttribute('data-legging');
    var duo = root.getAttribute('data-duo');
    var trio = root.getAttribute('data-trio');
    var leo = root.getAttribute('data-leopard') || 'legging-sculptant-leopard-vona';
    var label = root.getAttribute('data-shop-label') || 'High-Waist Sculpting Legging';

    function slug(s){ return norm(s).replace(/[^a-z0-9]+/g,'-').replace(/^-|-$/g,''); }
    function jl(h){ if (VROOT === '/') return Promise.resolve(null); return fetch(VROOT+'products/' + h + '.js').then(function(r){ return r.ok ? r.json() : null; }).catch(function(){ return null; }); }
    function j(h){ return fetch('/products/' + h + '.js').then(function(r){ return r.ok ? r.json() : null; }).catch(function(){ return null; }); }
    function pad(n){ return (n < 10 ? '0' : '') + n; }
    var heart = '<svg viewBox="0 0 24 24"><path d="M12 20s-7-4.3-9.2-8.5C1.2 8.3 3 5 6.2 5 8.3 5 12 7.5 12 7.5S15.7 5 17.8 5C21 5 22.8 8.3 21.2 11.5 19 15.7 12 20 12 20z"/></svg>';
    var plus = '<svg viewBox="0 0 24 24"><path d="M12 5v14M5 12h14"/></svg>';
    var cart = '<svg viewBox="0 0 24 24"><path d="M6 8h12l-1 11H7z"/><path d="M9 8V6.5a3 3 0 0 1 6 0V8"/></svg>';

    Promise.all([j(leg), j(duo), j(trio), leo ? j(leo) : Promise.resolve(null), jl(leg), leo ? jl(leo) : Promise.resolve(null)]).then(function (res) {
      var P = res[0]; if (!P) { grid.innerHTML = ''; return; }
      /* colour names shown in the visitor's language, images matched on the English filename */
      var frNames = {};
      function learnNames(EN, LOC) {
        if (!EN || !LOC) return;
        var co = (EN.options || []).filter(function (o) { return /couleur|color/i.test(o.name); })[0];
        var ci = co ? (co.position - 1) : 1;
        var byId = {};
        (LOC.variants || []).forEach(function (v) { byId[v.id] = (v.options || [])[ci]; });
        (EN.variants || []).forEach(function (v) { var en = (v.options || [])[ci]; if (en && byId[v.id]) frNames[en] = byId[v.id]; });
      }
      learnNames(res[0], res[4]); learnNames(res[3], res[5]);
      function frNameOf(c) { return frNames[c] || c; }
      var colourOpt = (P.options || []).filter(function (o) { return /couleur|color/i.test(o.name); })[0];
      var colours = colourOpt ? colourOpt.values : [];
      /* size option + colour|size -> variant map, for quick-add from the card */
      var sizeOpt = (P.options || []).filter(function (o) { return /taille|size/i.test(o.name); })[0];
      var sizes = sizeOpt ? sizeOpt.values : [];
      var colourIdx = colourOpt ? (colourOpt.position - 1) : 1;
      var sizeIdx = sizeOpt ? (sizeOpt.position - 1) : 0;
      var vmap = {};
      (P.variants || []).forEach(function (v) {
        var cs = slug((v.options || [])[colourIdx] || '');
        var sz = (v.options || [])[sizeIdx] || '';
        if (!vmap[cs]) vmap[cs] = {};
        vmap[cs][sz] = { id: v.id, available: v.available };
      });
      /* colour -> image, matched on filename start (provence-blue never eats blue) */
      var media = (P.media || P.images || []).map(function (m) { return typeof m === 'string' ? m : (m.src || ''); }); var vimg={};(P.variants||[]).forEach(function(v){var cs=slug((v.options||[])[colourIdx]||'');if(!vimg[cs]&&v.featured_image&&v.featured_image.src)vimg[cs]=v.featured_image.src;});
      function imgFor(c) {
        var h = slug(c); if (vimg[h]) return vimg[h];
        for (var i = 0; i < media.length; i++) {
          var f = media[i].split('/').pop().split('?')[0].toLowerCase();
          if (f.indexOf(h + '-0') === 0) return media[i];
        }
        return media[0] || '';
      }
      var legPrice = root.getAttribute('data-legging-price') || '';
      var cards = [];
      colours.forEach(function (c, i) {
        cards.push({
          group: 'solids', isNew: i < 2, colour: c,
          img: imgFor(c), brand: (root.getAttribute('data-series-solids') || 'Series 01 — Solids'), name: label, clr: frNameOf(c),
          price: legPrice, idx: frNameOf(c).toUpperCase() + ' / ' + pad(i + 1),
          chip: i < 2 ? 'New' : 'Sculpt', chipCls: i < 2 ? 'is-dark' : '',
          href: VROOT+'products/' + leg + '?vona-color=' + encodeURIComponent(c)
        });
      });
      function packCard(pk, hdl, name, idxLabel) {
        if (!pk) return null;
        return {
          group: 'packs', colour: '', img: pk.featured_image || (pk.media && pk.media[0] && pk.media[0].src) || '',
          brand: 'The Packs', name: name, clr: 'Mix sizes & colours',
          price: root.getAttribute('data-' + idxLabel + '-price') || '',
          was: root.getAttribute('data-' + idxLabel + '-was') || '',
          idx: idxLabel.toUpperCase() + ' / ' + (idxLabel === 'duo' ? '02' : '03'),
          chip: idxLabel === 'duo' ? 'Save' : 'Best value', chipCls: 'is-teal',
          href: VROOT+'products/' + hdl
        };
      }
      var dc = packCard(res[1], duo, 'Pack Duo — 2 Leggings', 'duo');
      var tc = packCard(res[2], trio, 'Pack Trio — 3 Leggings', 'trio');
      /* Series 02 — Leopard: real cards when the product is live, locked teaser otherwise */
      var L = res[3];
      var lColours = [];
      if (L) {
        var lColourOpt = (L.options || []).filter(function (o) { return /couleur|color/i.test(o.name); })[0];
        var lSizeOpt = (L.options || []).filter(function (o) { return /taille|size/i.test(o.name); })[0];
        lColours = lColourOpt ? lColourOpt.values : [];
        var lci = lColourOpt ? (lColourOpt.position - 1) : 1;
        var lsi = lSizeOpt ? (lSizeOpt.position - 1) : 0;
        (L.variants || []).forEach(function (v) {
          var cs = slug((v.options || [])[lci] || '');
          var sz = (v.options || [])[lsi] || '';
          if (!vmap[cs]) vmap[cs] = {};
          vmap[cs][sz] = { id: v.id, available: v.available };
        });
        var lMedia = (L.media || L.images || []).map(function (m) { return typeof m === 'string' ? m : (m.src || ''); });
        var imgForL = function (c) {
          var h = slug(c);
          for (var i = 0; i < lMedia.length; i++) {
            var f = lMedia[i].split('/').pop().split('?')[0].toLowerCase();
            if (f.indexOf(h + '-0') === 0) return lMedia[i];
          }
          return lMedia[0] || '';
        };
        var leoPrice = root.getAttribute('data-leopard-price') || legPrice;
        lColours.forEach(function (c, i) {
          cards.push({
            group: 'leopard', isNew: true, colour: c,
            img: imgForL(c), brand: (root.getAttribute('data-series-leo') || 'Series 02 — Leopard'), name: (root.getAttribute('data-leo-label') || 'Leopard Sculpting Legging'), clr: frNameOf(c),
            price: leoPrice, idx: frNameOf(c).toUpperCase() + ' / ' + pad(i + 1),
            chip: 'New', chipCls: 'is-dark',
            href: VROOT+'products/' + leo + '?vona-color=' + encodeURIComponent(c)
          });
        });
      } else {
        cards.push({ group: 'leopard', locked: true, img: imgFor('Provence Blue'),
          brand: 'Series 02 — Leopard', name: 'Leopard Sculpting Legging', clr: 'Coming soon',
          price: '', idx: 'LEOPARD', chip: 'Coming soon', chipCls: 'is-dark', href: '#' });
      }

      /* review aggregate (real data only; passed from the metafield server-side) */
      var rt = parseFloat(root.getAttribute('data-rating') || '0');
      var rc = parseInt(root.getAttribute('data-rating-count') || '0', 10);
      function starBits(v) {
        var s = '';
        for (var i = 1; i <= 5; i++) {
          s += '<span class="' + (v >= i ? 'is-on' : (v >= i - 0.5 ? 'is-half' : '')) + '"></span>';
        }
        return s;
      }
      function rateRow(k) {
        if (k.group !== 'solids' || rc <= 0) return '';
        var href = k.href + (k.href.indexOf('#') < 0 ? '#reviews' : '');
        return '<a class="v-card__rate" href="' + href + '" aria-label="' + rt.toFixed(1) + ' out of 5, ' + rc + ' reviews">' +
          '<span class="v-stars">' + starBits(rt) + '</span><b>' + rt.toFixed(1) + '</b><i>(' + rc + ')</i></a>';
      }

      grid.innerHTML = cards.map(function (k) {
        var wid = k.colour ? ('legging:' + slug(k.colour)) : (k.href || '');
        return '<article class="v-card' + (k.locked ? ' is-locked' : '') + '" data-group="' + k.group +
          '"' + (k.isNew ? ' data-new="1"' : '') + (k.colour ? ' data-colour="' + slug(k.colour) + '"' : '') +
          ' data-wish-id="' + wid + '">' +
          '<div class="v-card__top">' +
          '<a class="v-card__frame" href="' + k.href + '">' +
            '<span class="v-card__chip ' + (k.chipCls || '') + '">' + k.chip + '</span>' +
            (k.locked ? '<span class="v-card__lock">Notify me</span>' : '') +
            '<span class="v-card__idx">' + k.idx + '</span>' +
            '<img src="' + k.img + '" alt="' + k.name + ' ' + k.clr + '" loading="lazy">' +
          '</a>' +
          (k.locked ? '' : '<button class="v-card__heart" type="button" aria-label="Save to favourites" aria-pressed="false">' + heart + '</button>') +
          (k.locked ? '' :
            (k.group === 'packs'
              ? '<a class="v-card__cart" href="' + k.href + '" aria-label="View pack">' + cart + '</a>'
              : '<div class="v-card__add" data-add>' +
                  '<button class="v-card__cart" type="button" aria-label="' + (FR_LOCALE ? 'Ajouter au panier' : 'Quick add to cart') + '" data-qadd>' + cart + '</button>' +
                  '<div class="v-card__pop" data-pop hidden><span class="v-card__pop-h">' + (FR_LOCALE ? 'Ajouter · choisissez la taille' : 'Add · pick a size') + '</span><div class="v-card__pop-sz">' +
                    sizes.map(function (s) {
                      var vi = vmap[slug(k.colour)] && vmap[slug(k.colour)][s];
                      var av = vi && vi.available;
                      return '<button type="button" data-qsize="' + s + '"' + (av ? '' : ' disabled') + '>' + s.split(' ')[0] + '</button>';
                    }).join('') +
                  '</div></div>' +
                '</div>'
            )
          ) +
          '</div>' +
          '<div class="v-card__meta">' +
            '<div class="v-card__brand">' + k.brand + '</div>' +
            '<div class="v-card__name">' + k.name + '</div>' +
            '<div class="v-card__clr">' + k.clr + '</div>' +
            rateRow(k) +
            '<div class="v-card__foot"><div class="v-card__price">' + (k.price || '—') +
              (k.was ? '<s>' + k.was + '</s>' : '') + '</div>' +
              '<div class="v-card__trust">' + (k.locked ? 'S–XL' : (FR_LOCALE ? 'Opaque en squat' : 'Squat-proof')) + '</div></div>' +
          '</div></article>';
      }).join('');
      document.dispatchEvent(new CustomEvent('vona:cards'));
      try { var rem0 = localStorage.getItem('vona_size'); if (rem0) { $$('[data-qadd]', grid).forEach(function (b) { b.setAttribute('data-size', rem0.split(' ')[0]); }); } } catch (x) {}

      /* quick-add to cart straight from a colour card (size popover) */
      function addToCart(id) {
        var drawer = document.querySelector('cart-drawer');
        var sids = (drawer && typeof drawer.getSectionsToRender === 'function') ? drawer.getSectionsToRender().map(function (s) { return s.id; }) : [];
        var body = { items: [{ id: id, quantity: 1 }] };
        if (sids.length) { body.sections = sids; body.sections_url = window.location.pathname; }
        return fetch(VROOT+'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) })
          .then(function (r) { return r.json(); })
          .then(function (r) {
            if (drawer && typeof drawer.renderContents === 'function' && r.sections) { drawer.renderContents(r); if (typeof drawer.open === 'function') drawer.open(); document.dispatchEvent(new CustomEvent('cart:refresh')); }
            else { window.location = '/cart'; }
          })
          .catch(function () { window.location = '/cart'; });
      }
      grid.addEventListener('click', function (e) {
        var qadd = e.target.closest('[data-qadd]');
        var qsize = e.target.closest('[data-qsize]');
        if (qadd) {
          e.preventDefault();
          /* size remembered after the first pick: every next bag icon adds in one tap, adjustable in the cart */
          var rem = null; try { rem = localStorage.getItem('vona_size'); } catch (x) {}
          var card0 = qadd.closest('.v-card');
          var vi0 = rem && card0 && vmap[card0.getAttribute('data-colour')] && vmap[card0.getAttribute('data-colour')][rem];
          if (vi0 && vi0.available) { addToCart(vi0.id); return; }
          var pop = qadd.parentNode.querySelector('[data-pop]');
          $$('[data-pop]', grid).forEach(function (p) { if (p !== pop) p.hidden = true; });
          if (pop) pop.hidden = !pop.hidden;
          return;
        }
        if (qsize) {
          e.preventDefault();
          if (qsize.disabled) return;
          var card = qsize.closest('.v-card');
          var vi = vmap[card.getAttribute('data-colour')] && vmap[card.getAttribute('data-colour')][qsize.getAttribute('data-qsize')];
          if (!vi) return;
          var pp = qsize.closest('[data-pop]'); if (pp) pp.hidden = true;
          try { localStorage.setItem('vona_size', qsize.getAttribute('data-qsize')); } catch (x) {}
          $$('[data-qadd]', grid).forEach(function (b) { b.setAttribute('data-size', qsize.getAttribute('data-qsize').split(' ')[0]); });
          addToCart(vi.id);
        }
      });
      document.addEventListener('click', function (e) {
        if (!e.target.closest('[data-add]')) { $$('[data-pop]', grid).forEach(function (p) { p.hidden = true; }); }
      });

      /* the packs leave the colourway grid and get their own "buy more, pay
         less" band below it, with a composed shot from the new solid photos
         — never the old supplier group images. */
      var packs = [];
      if (dc) { dc.shots = [imgFor('Black'), imgFor('Raspberry')]; dc.save = root.getAttribute('data-duo-save') || ''; packs.push(dc); }
      if (tc) { tc.shots = [imgFor('Black'), imgFor('Green'), imgFor('Provence Blue')]; tc.save = root.getAttribute('data-trio-save') || ''; packs.push(tc); }
      var band = $('[data-v-btq-packs]', root);
      if (band && packs.length) {
        band.innerHTML =
          '<div class="v-btq__packs-head"><span class="v-btq__packs-eye">' + (FR_LOCALE ? 'Les Packs' : 'The Packs') + '</span>' +
          '<h2 class="v-btq__packs-h">' + (FR_LOCALE ? 'Plus vous en prenez, moins c\'est cher' : 'Buy more, pay less') + '</h2>' +
          '<p class="v-btq__packs-sub">' + (FR_LOCALE ? 'Mélangez tailles et couleurs sur chaque legging du pack.' : 'Mix sizes and colours across every legging in the pack.') + '</p></div>' +
          '<div class="v-btq__packs-grid">' + packs.map(function (p) {
            return '<article class="v-pack" data-count-n="' + p.shots.length + '">' +
              '<a class="v-pack__shots" href="' + p.href + '" aria-label="' + p.name + '">' +
                p.shots.map(function (s) { return '<span style="background-image:url(' + s + ')"></span>'; }).join('') +
              '</a>' +
              '<div class="v-pack__meta">' +
                '<div class="v-pack__name">' + p.name + '</div>' +
                '<div class="v-pack__sub">' + (FR_LOCALE ? 'Tailles et couleurs au choix' : 'Mix sizes &amp; colours') + '</div>' +
                '<div class="v-pack__foot"><span class="v-pack__price">' + (p.price || '') +
                  (p.was ? '<s>' + p.was + '</s>' : '') + '</span>' +
                  (p.save ? '<span class="v-pack__save">' + (FR_LOCALE ? 'Économisez ' : 'Save ') + p.save + '</span>' : '') + '</div>' +
                '<a class="v-pack__cta" href="' + p.href + '">' + (FR_LOCALE ? 'Voir le pack' : 'Shop the pack') + ' &rarr;</a>' +
              '</div></article>';
          }).join('') + '</div>';
      }

      /* swatches */
      var sw = $('[data-v-btq-swatches]', root);
      if (sw) {
        sw.innerHTML = colours.concat(lColours).map(function (c) {
          return '<span title="' + c + '" data-colour="' + slug(c) + '" style="background:' + swatchFor(c) + '"></span>';
        }).join('');
      }
      /* counts */
      function count(g){ return g === 'packs' ? packs.length : cards.filter(function(k){ return g === 'all' ? true : g === 'new' ? k.isNew : k.group === g; }).length; }
      $$('[data-count]', root).forEach(function (b) { var g = b.getAttribute('data-count'); b.textContent = count(g); });
      var tot = $('[data-total]', root); if (tot) tot.textContent = (colours.length + lColours.length) + (FR_LOCALE ? ' coloris' : ' colourways');

      wireFilters(root, grid);
    });
  }

  function wireFilters(root, grid) {
    /* small screens: the filter rail folds behind its header */
    var aside = root.querySelector('[data-v-btq-aside]');
    var tog = root.querySelector('[data-v-btq-toggle]');
    if (aside && tog) {
      tog.addEventListener('click', function () {
        if (window.innerWidth > 1100) return;
        var open = aside.getAttribute('aria-expanded') === 'true';
        aside.setAttribute('aria-expanded', open ? 'false' : 'true');
        tog.setAttribute('aria-expanded', open ? 'false' : 'true');
      });
    }
    var state = { pill: 'all', colour: null, colls: [] };
    function apply() {
      $$('.v-card', grid).forEach(function (c) {
        var g = c.getAttribute('data-group');
        var isNew = c.getAttribute('data-new') === '1';
        var col = c.getAttribute('data-colour');
        var ok = true;
        if (state.pill === 'new') ok = isNew;
        else if (state.pill !== 'all') ok = g === state.pill;
        if (ok && state.colls.length) ok = state.colls.indexOf(g) > -1;
        if (ok && state.colour) ok = col === state.colour;
        c.hidden = !ok;
      });
    }
    /* pills */
    var pills = $('[data-v-btq-pills]', root);
    if (pills) pills.addEventListener('click', function (e) {
      var b = e.target.closest('.v-btq__pill'); if (!b) return;
      $$('.v-btq__pill', pills).forEach(function (x) { x.classList.remove('is-on'); });
      b.classList.add('is-on'); state.pill = b.getAttribute('data-filter'); apply();
    });
    /* facet accordions */
    $$('.v-facet > button', root).forEach(function (btn) {
      btn.addEventListener('click', function () { btn.parentElement.classList.toggle('is-open'); });
    });
    /* colour swatches */
    var sw = $('[data-v-btq-swatches]', root);
    if (sw) sw.addEventListener('click', function (e) {
      var s = e.target.closest('span'); if (!s) return;
      var c = s.getAttribute('data-colour');
      if (state.colour === c) { state.colour = null; s.classList.remove('is-on'); }
      else { $$('span', sw).forEach(function (x) { x.classList.remove('is-on'); }); s.classList.add('is-on'); state.colour = c; }
      apply();
    });
    /* collection checkboxes */
    $$('[data-coll]', root).forEach(function (cb) {
      cb.addEventListener('change', function () {
        state.colls = $$('[data-coll]', root).filter(function (x) { return x.checked; }).map(function (x) { return x.getAttribute('data-coll'); });
        apply();
      });
    });
  }


  /* ---------- 10% welcome badge + newsletter modal ---------- */
  function reward10() {
    var wrap = $('[data-v-reward10]');
    var modal = $('[data-v-reward10-modal]');
    if (!wrap || !modal) return;
    var KEY = 'vona_reward10';
    function stored(k){ try { return sessionStorage.getItem(k); } catch (e) { return null; } }
    function store(k, v){ try { sessionStorage.setItem(k, v); } catch (e) {} }

    /* if they already opened it and it posted, or dismissed, keep the badge quiet this session */
    if (stored(KEY) !== 'hidden') {
      setTimeout(function () { wrap.hidden = false; }, 1200);
    }
    /* a form that just posted successfully should show the modal open with the thank-you */
    if (modal.querySelector('.v-modal__ok')) { wrap.hidden = false; open(); }

    function open(){ modal.classList.add('is-open'); document.body.style.overflow = 'hidden'; }
    function close(){ modal.classList.remove('is-open'); document.body.style.overflow = ''; }

    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-v-reward10-open]')) { open(); }
      else if (e.target.closest('[data-v-reward10-close]')) { close(); }
      else if (e.target.closest('[data-v-reward10-hide]')) { wrap.classList.add('is-hidden'); store(KEY, 'hidden'); }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  }

  /* ---------- favourites / wishlist (per browser, localStorage) ---------- */
  function wishlist() {
    var KEY = 'vona_wishlist';
    function read() { try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { return []; } }
    function write(a) { try { localStorage.setItem(KEY, JSON.stringify(a)); } catch (e) {} }
    function has(id) { return read().indexOf(id) > -1; }
    function toggle(id) { var a = read(); var i = a.indexOf(id); if (i > -1) a.splice(i, 1); else a.push(id); write(a); return i < 0; }
    function idOf(el) {
      var card = el.closest('[data-wish-id]');
      if (card && card.getAttribute('data-wish-id')) return card.getAttribute('data-wish-id');
      var pdp = el.closest('[data-v-wish-id]');
      if (pdp) return pdp.getAttribute('data-v-wish-id');
      return null;
    }
    function paint() {
      $$('.v-card__heart, [data-v-wish]').forEach(function (h) {
        var id = idOf(h); if (!id) return;
        var on = has(id);
        h.classList.toggle('is-saved', on);
        h.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      var count = read().length;
      $$('[data-v-wish-count]').forEach(function (b) { b.textContent = count; b.hidden = count === 0; });
    }
    document.addEventListener('click', function (e) {
      var h = e.target.closest('.v-card__heart, [data-v-wish]');
      if (!h) return;
      e.preventDefault(); e.stopPropagation();
      var id = idOf(h); if (!id) return;
      toggle(id);
      paint();
    });
    document.addEventListener('vona:cards', paint);
    paint();
  }

  /* ---------- product reviews: filter / sort / search over real reviews ---------- */
  function reviews() {
    var root = $('[data-v-reviews]');
    if (!root) return;
    var list = $('[data-v-rev-list]', root);
    if (!list) return;
    var items = $$('.v-rev', list);
    if (!items.length) return; /* empty state handled server-side */

    var search = $('[data-v-rev-search]', root);
    var sortSel = $('[data-v-rev-sort]', root);
    var filterWrap = $('[data-v-rev-filter]', root);
    var state = { q: '', sort: 'recent', stars: 0 };

    function apply() {
      var visible = items.filter(function (el) {
        if (state.stars && parseInt(el.getAttribute('data-rating'), 10) !== state.stars) return false;
        if (state.q) {
          var hay = (el.getAttribute('data-text') || '').toLowerCase();
          if (hay.indexOf(state.q) < 0) return false;
        }
        return true;
      });
      visible.sort(function (a, b) {
        if (state.sort === 'high') return parseFloat(b.getAttribute('data-rating')) - parseFloat(a.getAttribute('data-rating'));
        if (state.sort === 'low') return parseFloat(a.getAttribute('data-rating')) - parseFloat(b.getAttribute('data-rating'));
        return parseInt(b.getAttribute('data-ts') || '0', 10) - parseInt(a.getAttribute('data-ts') || '0', 10);
      });
      items.forEach(function (el) { el.hidden = true; });
      visible.forEach(function (el) { el.hidden = false; list.appendChild(el); });
      var empty = $('[data-v-rev-empty]', root);
      if (empty) empty.hidden = visible.length !== 0;
    }

    if (search) search.addEventListener('input', function () { state.q = search.value.trim().toLowerCase(); apply(); });
    if (sortSel) sortSel.addEventListener('change', function () { state.sort = sortSel.value; apply(); });
    if (filterWrap) filterWrap.addEventListener('click', function (e) {
      var b = e.target.closest('[data-stars]'); if (!b) return;
      var v = parseInt(b.getAttribute('data-stars'), 10);
      state.stars = (state.stars === v) ? 0 : v;
      $$('[data-stars]', filterWrap).forEach(function (x) { x.classList.toggle('is-on', parseInt(x.getAttribute('data-stars'), 10) === state.stars); });
      apply();
    });
    apply();
  }

  /* ---------- cart-count pulse on any add ---------- */
  function cartPulse() {
    var bubble = $('#cart-icon-bubble') || $('.header__icon--cart') || $('[id*="cart-icon"]');
    if (!bubble || !('MutationObserver' in window)) return;
    function pulse() { bubble.classList.remove('v-cartpulse'); void bubble.offsetWidth; bubble.classList.add('v-cartpulse'); }
    new MutationObserver(pulse).observe(bubble, { childList: true, subtree: true, characterData: true });
  }

  /* ---------- pack builder (duo = 2 leggings, trio = 3) ---------- */
  function packBuilder() {
    var root = $('[data-v-packb]');
    if (!root) return;
    var count = parseInt(root.getAttribute('data-count'), 10) || 2;
    var variants = [];
    try { variants = JSON.parse(root.getAttribute('data-variants') || '[]'); } catch (e) { variants = []; }
    var addBtn = $('[data-v-packb-add]', root);
    var buyBtn = $('[data-v-packb-buynow]', root);
    var err = $('[data-err]', root);

    /* paint colour swatches from the shared VONA colour map */
    $$('.v-packb__c', root).forEach(function (b) {
      var dot = b.firstElementChild;
      if (dot) dot.style.background = swatchFor(b.getAttribute('data-colour'));
    });

    function slots() { return $$('.v-packb__slot', root); }
    function complete() {
      return slots().every(function (s) {
        return s.getAttribute('data-colour') && s.getAttribute('data-size');
      });
    }
    function shortSize(s) { return (s || '').split(' ')[0]; }

    function refresh() {
      slots().forEach(function (s) {
        var ok = s.getAttribute('data-colour') && s.getAttribute('data-size');
        var st = $('[data-state]', s);
        if (st) {
          st.textContent = ok
            ? (s.getAttribute('data-colour') + ' · ' + shortSize(s.getAttribute('data-size')))
            : (root.getAttribute('data-t-state') || 'Choose colour & size');
          st.classList.toggle('is-ok', !!ok);
        }
        s.classList.toggle('is-done', !!ok);
      });
      if (addBtn) addBtn.disabled = !complete();
      if (buyBtn) buyBtn.disabled = !complete();
      if (err) err.hidden = true;
    }

    root.addEventListener('click', function (e) {
      var slot = e.target.closest('.v-packb__slot');
      if (!slot) return;
      var cb = e.target.closest('.v-packb__c');
      var sb = e.target.closest('.v-packb__s');
      if (cb) {
        $$('.v-packb__c', slot).forEach(function (x) { x.classList.remove('is-on'); });
        cb.classList.add('is-on');
        slot.setAttribute('data-colour', cb.getAttribute('data-colour'));
        var cn = $('[data-cname]', slot);
        if (cn) cn.textContent = cb.getAttribute('data-colour');
        refresh();
      } else if (sb) {
        $$('.v-packb__s', slot).forEach(function (x) { x.classList.remove('is-on'); });
        sb.classList.add('is-on');
        slot.setAttribute('data-size', sb.getAttribute('data-size'));
        refresh();
      }
    });

    function submitPack(btn, goCheckout) {
      if (!complete()) { if (err) err.hidden = false; return; }
      var firstSize = slots()[0].getAttribute('data-size');
      var v = variants.filter(function (x) {
        return x.option1 === firstSize || x.title === firstSize;
      })[0] || variants[0];
      if (!v) { window.location = '/cart'; return; }

      var props = {};
      slots().forEach(function (s, i) {
        props['Legging ' + (i + 1)] = s.getAttribute('data-colour') + ' · ' + s.getAttribute('data-size');
      });

      btn.disabled = true;
      btn.classList.add('is-loading');

      var drawer = document.querySelector('cart-drawer');
      var sectionIds = [];
      if (!goCheckout && drawer && typeof drawer.getSectionsToRender === 'function') {
        sectionIds = drawer.getSectionsToRender().map(function (s) { return s.id; });
      }
      var body = { items: [{ id: v.id, quantity: 1, properties: props }] };
      if (sectionIds.length) { body.sections = sectionIds; body.sections_url = window.location.pathname; }

      fetch(VROOT+'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(body)
      })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          btn.classList.remove('is-loading');
          btn.disabled = false;
          if (res && res.status && res.status !== 200 && res.description) {
            if (err) { err.hidden = false; err.textContent = res.description; }
            return;
          }
          if (goCheckout) { window.location = VROOT+'checkout'; return; }
          if (drawer && typeof drawer.renderContents === 'function' && res.sections) {
            drawer.renderContents(res);
            if (typeof drawer.open === 'function') { drawer.open(); }
            document.dispatchEvent(new CustomEvent('cart:refresh'));
          } else {
            window.location = '/cart';
          }
        })
        .catch(function () {
          btn.classList.remove('is-loading');
          btn.disabled = false;
          window.location = goCheckout ? '/checkout' : '/cart';
        });
    }

    if (addBtn) addBtn.addEventListener('click', function () { submitPack(addBtn, false); });
    if (buyBtn) buyBtn.addEventListener('click', function () { submitPack(buyBtn, true); });

    refresh();
  }

  function init() {
    offRegisterOnScroll();
    rotator();
    filters();
    stickyBuy();
    watchOptions();
    upsells();
    translateCartOptions();
    fixNav();
    setTimeout(preselectColor, 400);
    bundle();
    mediaColour();
    boutique();
    packBuilder();
    wishlist();
    reviews();
    cartPulse();
    reward10();
    openSizeOnDesktop();
    wrapTables();
    dressCards();
    window.addEventListener('load', dressCards);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }

  /* Dawn re-renders the cart drawer via the Section Rendering API — re-arm. */
  document.addEventListener('cart:refresh', function () { offRegisterOnScroll(); translateCartOptions(); });
  /* the drawer is redrawn server-side on every cart change */
  new MutationObserver(function () { translateCartOptions(); fixNav(); })
    .observe(document.documentElement, { childList: true, subtree: true });
})();


/* VONA — change the size inside the cart drawer (swap variant, keep quantity) */
document.addEventListener('change', function (e) {
  var sel = e.target.closest('[data-v-cart-size]');
  if (!sel) return;
  var oldId = sel.getAttribute('data-current'), newId = sel.value, qty = parseInt(sel.getAttribute('data-qty') || '1', 10);
  if (!oldId || !newId || oldId === newId) return;
  var drawer = document.querySelector('cart-drawer');
  var sids = (drawer && typeof drawer.getSectionsToRender === 'function') ? drawer.getSectionsToRender().map(function (s) { return s.id; }) : [];
  var updates = {}; updates[oldId] = 0; updates[newId] = qty;
  var body = { updates: updates };
  if (sids.length) { body.sections = sids; body.sections_url = window.location.pathname; }
  sel.disabled = true;
  fetch(VROOT + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) })
    .then(function (r) { return r.json(); })
    .then(function (r) {
      if (drawer && typeof drawer.renderContents === 'function' && r.sections) { drawer.renderContents(r); document.dispatchEvent(new CustomEvent('cart:refresh')); }
      else { window.location.reload(); }
    })
    .catch(function () { window.location.reload(); });
});
